import { type RootState } from '../../../rmsReduxStore/rmsStore'

export default function getAcReportReducer(state: RootState): AcReportState {
  return state.acreportsReducer;
}
